/* The article script. Built by tools/build-assets.mjs from the review set; edit the review set, not this file. */
/* XGO pages of words (Playbook parts 32 and 33): an article, or a plain page, set in one column. An article's body arrives as
   the blog editor wrote it; this script gives it the site's parts before the page script runs, so the entrance, the anchors and
   the video frame bind to what it makes. It never changes a word: it takes the editor's markup and sets it in the site's parts.
   0. The title: the h1 takes the two weights of every headline, every word as typed: heavy to its first break (a colon or a dash;
      How to and its verb; or the first of to, for, with, your, and, on, in, of or from after two words), light after it. A title
      with no break takes its last two words light, where it has four or more; a shorter one stays in one weight.
   1. Video: a YouTube frame in the body becomes the video frame: its poster and the orange play button, which says what it
      plays to a screen reader. The poster is YouTube's own and often carries the video's title, so the frame adds no words over
      it. The player loads only when it is pressed (web.js, as on the fleet page).
   2. Products: a line that holds nothing but links to products becomes a row of product cards on their side, read from the page's
      product data (#ti-products; at the port the article template writes it from the links in the body). Lines of products one
      after another share a row. A link to a product the store no longer has is a dashed card while the page is being edited
      (data-review on the page root; at the port, the theme editor) and is left out for customers.
   3. Lead-ins: a short line in bold, or one ending on a colon or a question mark, just before a list, a row of products or
      another lead-in, is set as a caps label.
   4. A fitting guide: its editor types the facts as a bold label ending on a colon over a line (Tools Required:, Time
      Requirement:) or opening its own (Bluetooth Application:), the steps as bold numbered lines (1. Remove Battery Connection),
      and a caution as a line opening in bold on Note:, Attention!, Warning:, Caution: or Important:. A label is set as a lead-in,
      a numbered line as a step with its number in orange, a caution on the orange rule. Every word stays as typed, a skipped step
      too.
   5. A picture opens whole: each picture in the words is a button that opens it at full size in the viewer (pages.js), shown
      whole at any width, so a wiring drawing can be read on a phone.
   6. The contents: each h2 in the body takes an id from its words and the rail lists them, where there are three or more. On a
      desktop the rail stays open beside the column and marks the section in view; on a phone it is a closed box under the head.
   A page with no script shows the editor's markup, restyled by web.css. */
(function () {
  var root = document.documentElement;
  if (!root) return;
  var body = root.querySelector('[data-words]');
  if (!body || body.dataset.wordsDone) return;
  body.dataset.wordsDone = '1';
  var norm = function (s) { return (s || '').replace(/\s+/g, ' ').trim(); };
  var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };

  /* ---------- a heading or a line the editor left empty takes no room ---------- */
  [].forEach.call(body.querySelectorAll('h2, h3, h4, p'), function (el) {
    if (!norm(el.textContent) && !el.querySelector('img, iframe, video')) el.classList.add('ti-void');
  });

  /* ---------- 0. the title in two weights ---------- */
  var h1 = root.querySelector('.ti-art__head h1.ti-h1--title');
  if (h1 && !h1.querySelector('b')) {
    var full = norm(h1.textContent), cut = -1, m0;
    var ws = full.split(' ');
    if ((m0 = /:\s|\s[-\u2013\u2014]\s/.exec(full))) cut = m0.index + (full.charAt(m0.index) === ':' ? 1 : 2);
    else if ((m0 = /^how to \S+/i.exec(full)) && m0[0].length < full.length) cut = m0[0].length;
    else {
      for (var k = 2; k < ws.length; k++) if (/^(to|for|with|your|and|on|in|of|from)$/i.test(ws[k])) { cut = ws.slice(0, k).join(' ').length; break; }
      if (cut < 0 && ws.length >= 4) cut = ws.slice(0, ws.length - 2).join(' ').length;
    }
    if (cut > 0 && cut < full.length) h1.innerHTML = '<b>' + esc(full.slice(0, cut).trim()) + '</b> <span>' + esc(full.slice(cut).trim()) + '</span>';
  }

  /* ---------- 1. video ---------- */
  var headingBefore = function (el) {
    for (var n = el.previousElementSibling; n; n = n.previousElementSibling) if (/^H[23]$/.test(n.tagName)) return norm(n.textContent);
    return '';
  };
  /* a video's poster: one of our own where the page names one for it (data-posters, the video's id to its photograph: the theme
     writes the posters its video records hold); else YouTube's own, the large frame, then the standard one, then the small one,
     each passed over when YouTube has none for an older upload (a missing file, or its 120 px placeholder) */
  var posters = {};
  var pf = root.querySelector('[data-posters]');
  if (pf) { try { posters = JSON.parse(pf.getAttribute('data-posters')) || {}; } catch (e) { posters = {}; } }
  var FRAMES = ['maxresdefault', 'sddefault', 'hqdefault'];
  [].forEach.call(body.querySelectorAll('iframe'), function (f) {
    var m = (f.getAttribute('src') || '').match(/youtube(?:-nocookie)?\.com\/embed\/([\w-]{11})/);
    if (!m) return;
    var host = f.closest('p');                                   // the editor puts a frame in a paragraph, sometimes in bold too
    if (!host || !body.contains(host) || norm(host.textContent)) host = f;   // words beside the frame stay where they are
    var near = headingBefore(host === f ? (f.closest('p') || f) : host);
    var own = posters[m[1]];
    var v = document.createElement('div');
    v.className = 'ti-vid';
    v.setAttribute('data-vid', m[1]);
    v.innerHTML = '<button type="button" class="ti-vid__btn" data-vid-play aria-label="' + esc('Play video' + (near ? ': ' + near : '')) + '">' +
      '<img src="' + esc(own || 'https://i.ytimg.com/vi/' + m[1] + '/' + FRAMES[0] + '.jpg') + '" alt="" loading="lazy" decoding="async">' +
      '<span class="ti-vid__play" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8.4 5.6 19 12 8.4 18.4z"/></svg></span></button>';
    var img = v.querySelector('img');
    if (!own) {
      var at = 0;
      var next = function () { if (at < FRAMES.length - 1) { at++; img.src = 'https://i.ytimg.com/vi/' + m[1] + '/' + FRAMES[at] + '.jpg'; } };
      img.addEventListener('load', function () { if (img.naturalWidth && img.naturalWidth <= 120) next(); });
      img.addEventListener('error', next);
    }
    host.parentNode.replaceChild(v, host);
  });

  /* ---------- 2. products ---------- */
  var data = {};
  var feed = root.querySelector('#ti-products');
  if (feed) { try { data = JSON.parse(feed.textContent).products || {}; } catch (e) { data = {}; } }
  var review = root.hasAttribute('data-review');
  var PRODUCT = /\/products\/([a-z0-9%-]+)/i;
  var handleOf = function (a) { var m = (a.getAttribute('href') || '').match(PRODUCT); return m ? decodeURIComponent(m[1]).toLowerCase() : null; };
  var card = function (h, label) {
    var p = data[h];
    if (!p) {
      if (!review) return null;
      var g = document.createElement('span');
      g.className = 'ti-pc ti-pc--row ti-pc--gone';
      g.innerHTML = '<span class="ti-pc__m" aria-hidden="true"></span><span class="ti-pc__b"><strong class="ti-pc__n">' + esc(label) + '</strong>' +
        '<span class="ti-pc__f">No longer in the store. Shown while editing, left out for customers</span></span>';
      return g;
    }
    var a = document.createElement('a');
    a.className = 'ti-pc ti-pc--row';
    a.href = 'https://teralumeindustries.com/products/' + h;
    if (p.id) a.setAttribute('data-product', p.id);
    if (p.v) a.setAttribute('data-variant', p.v);
    a.setAttribute('data-price', p.p);
    var st = { in: 'In stock', back: 'Backorder', out: 'Sold out' }[p.s] || 'In stock';
    a.innerHTML = '<span class="ti-pc__m"><img src="' + esc(p.img) + '" alt="' + esc(p.alt || '') + '" loading="lazy" decoding="async"></span>' +
      '<span class="ti-pc__b"><strong class="ti-pc__n">' + p.n + '</strong>' + (p.f ? '<span class="ti-pc__f">' + p.f + '</span>' : '') +
      '<span class="ti-pc__p" data-spark="b2c-only">' + (p.from ? '<span class="ti-pc__from">From</span>' : '') + '<b>$' + esc(p.p) + '</b>' + (p.c ? '<s>$' + esc(p.c) + '</s>' : '') + '</span>' +   // priced by size or option: its lowest, after From
      '<span class="ti-pc__s" data-st="' + esc(p.s || 'in') + '">' + st + '</span></span>';
    return a;
  };
  [].slice.call(body.querySelectorAll('p')).forEach(function (p) {
    var links = [].filter.call(p.querySelectorAll('a[href]'), function (a) { return handleOf(a); });
    if (!links.length) return;
    var rest = p.cloneNode(true);
    [].forEach.call(rest.querySelectorAll('a[href]'), function (a) { if (handleOf(a)) a.parentNode.removeChild(a); });
    var left = norm(rest.textContent);
    if (left && (left.length > 40 || !/[:?]$/.test(left))) return;   // a sentence with a product link in it keeps its link
    var row = document.createElement('div');
    row.className = 'ti-pcs ti-pcs--rows ti-pcs--words';
    links.forEach(function (a) { var c = card(handleOf(a), norm(a.textContent)); if (c) row.appendChild(c); });
    if (!row.children.length) {   // nothing left to show: the line goes, and a lead-in that only introduced it goes with it
      var before = p.previousElementSibling;
      if (before && before.tagName === 'P' && !before.querySelector('a, img, iframe') && norm(before.textContent).length <= 40 && /[:?]$/.test(norm(before.textContent))) before.parentNode.removeChild(before);
      p.parentNode.removeChild(p);
      return;
    }
    if (left) { var lead = document.createElement('p'); lead.textContent = left; p.parentNode.insertBefore(lead, p); }   // the editor's own lead-in, kept
    p.parentNode.replaceChild(row, p);
  });
  [].slice.call(body.querySelectorAll('.ti-pcs--words')).forEach(function (row) {   // one line of products after another: one row
    var prev = row.previousElementSibling;
    if (prev && prev.classList.contains('ti-pcs--words')) { while (row.firstChild) prev.appendChild(row.firstChild); row.parentNode.removeChild(row); }
  });

  /* ---------- 3. lead-ins, from the foot up, so a lead-in over a lead-in is found ---------- */
  var leadsTo = function (el) { return el && (/^(UL|OL)$/.test(el.tagName) || el.classList.contains('ti-pcs--words') || el.classList.contains('ti-lead')); };
  [].slice.call(body.querySelectorAll('p')).reverse().forEach(function (p) {
    if (p.querySelector('img, iframe, a')) return;
    var t = norm(p.textContent);
    if (!t || t.length > 40) return;
    var bold = norm([].map.call(p.querySelectorAll('strong, b'), function (s) { return s.textContent; }).join(' '));
    if (bold !== t && !/[:?]$/.test(t)) return;
    if (leadsTo(p.nextElementSibling)) p.classList.add('ti-lead');
  });

  /* ---------- 4. a fitting guide: the facts, the steps and a caution ---------- */
  var firstNode = function (el) { var n = el.firstChild; while (n && n.nodeType === 3 && !n.nodeValue.trim()) n = n.nextSibling; return n; };
  var boldOf = function (el) { return norm([].map.call(el.querySelectorAll('strong, b'), function (s) { return s.textContent; }).join(' ')); };
  [].forEach.call(body.querySelectorAll('p'), function (p) {
    if (p.classList.contains('ti-void') || p.classList.contains('ti-lead') || p.querySelector('img, iframe, a')) return;
    var t = norm(p.textContent), bold = boldOf(p), lead = firstNode(p);
    if (!t) return;
    if (bold === t && t.length <= 40 && /:$/.test(t)) {   /* a label over the line that holds its value */
      var nx = p.nextElementSibling;
      if (nx && nx.tagName === 'P' && !nx.classList.contains('ti-void')) p.classList.add('ti-lead');
      return;
    }
    if (lead && lead.nodeType === 1 && /^(STRONG|B)$/.test(lead.tagName) && /:$/.test(norm(lead.textContent)) && norm(lead.textContent).length <= 40 &&
        lead.nextSibling && lead.nextSibling.nodeName === 'BR') {   /* a label opening its own line: Bluetooth Application:<br>Happy Lighting */
      lead.classList.add('ti-lead');
      return;
    }
    var m = /^(\d{1,2}[.)])\s+\S/.exec(t);
    if (m && bold === t && t.length <= 80) {   /* a step: its number, as typed, in orange */
      p.classList.add('ti-step');
      var walk = document.createTreeWalker(p, NodeFilter.SHOW_TEXT), tn;
      while ((tn = walk.nextNode()) && !/\d/.test(tn.nodeValue)) {}
      if (tn) {
        var num = tn.splitText(tn.nodeValue.search(/\d/));
        num.splitText(m[1].length);
        var span = document.createElement('span');
        span.className = 'ti-step__n';
        num.parentNode.replaceChild(span, num);
        span.appendChild(num);
      }
      return;
    }
    if (/^(note|attention|warning|caution|important)\s*[:!]/i.test(t) && lead && lead.nodeType === 1 && /^(STRONG|B)$/.test(lead.tagName)) p.classList.add('ti-heed');
  });

  /* ---------- 5. a picture opens whole ---------- */
  var titled = norm((root.querySelector('.ti-art__head h1') || {}).textContent) || 'Photographs';
  [].forEach.call(body.querySelectorAll('img'), function (img) {
    if (img.closest('.ti-pcs--words, .ti-vid, a, button')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ti-zoom';
    b.setAttribute('data-view-src', img.getAttribute('src'));
    b.setAttribute('data-view-group', titled);
    b.setAttribute('data-view-fit', 'whole');
    b.setAttribute('aria-label', img.alt ? img.alt : 'Photograph');
    b.title = 'Open at full size';
    img.parentNode.insertBefore(b, img);
    b.appendChild(img);
  });

  /* ---------- 6. the contents ---------- */
  var h2s = [].slice.call(body.querySelectorAll('h2:not(.ti-void)'));
  var toc = root.querySelector('[data-toc]');
  var used = {};
  h2s.forEach(function (h) {
    var base = norm(h.textContent).toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
    var id = h.id || base, n = 2;
    while (!h.id && (used[id] || document.getElementById(id))) id = base + '-' + n++;
    h.id = id; used[id] = 1;
  });
  if (!toc) return;
  if (h2s.length < 3) { toc.parentNode.removeChild(toc); return; }
  var grid = toc.closest('.ti-art__grid');
  if (grid) grid.classList.add('has-toc');
  toc.innerHTML = '<details class="ti-toc__box"><summary><span class="ti-label">On this page</span><span class="ti-toc__n">' + h2s.length + ' sections</span></summary><ol>' +
    h2s.map(function (h) { return '<li><a href="#' + esc(h.id) + '">' + esc(norm(h.textContent)) + '</a></li>'; }).join('') + '</ol></details>';
  var box = toc.querySelector('details');
  var wide = window.matchMedia ? window.matchMedia('(min-width: 1100px)') : { matches: true };
  var fit = function () { box.open = wide.matches; };   // open beside the column on a desktop, closed under the head on a phone
  fit();
  if (wide.addEventListener) wide.addEventListener('change', fit);
  box.querySelector('summary').addEventListener('click', function (e) { if (wide.matches) e.preventDefault(); });
  var links = [].slice.call(toc.querySelectorAll('a'));
  links.forEach(function (a) { a.addEventListener('click', function () { if (!wide.matches) box.open = false; }); });
  var mark = function () {
    var on = -1;
    for (var i = 0; i < h2s.length; i++) if (h2s[i].getBoundingClientRect().top < 140) on = i;
    links.forEach(function (a, i) { if (i === on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
  };
  var ticking = false;
  window.addEventListener('scroll', function () { if (ticking) return; ticking = true; window.requestAnimationFrame(function () { ticking = false; mark(); }); }, { passive: true });
  mark();
})();
